import { render, staticRenderFns } from "./HasilKajianGuru.vue?vue&type=template&id=01dcedc6&scoped=true&"
import script from "./HasilKajianGuru.vue?vue&type=script&lang=js&"
export * from "./HasilKajianGuru.vue?vue&type=script&lang=js&"
import style0 from "./HasilKajianGuru.vue?vue&type=style&index=0&id=01dcedc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dcedc6",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QBtn});
